import React, {useContext, useEffect, useState} from 'react';
import { Routes , Route, useNavigate, useSearchParams} from "react-router-dom";
import { AppRoutes } from "../routes";
import UserContext from '../utils/context/user/userContext';

// pages
import Presentation from "./public/Presentation/Presentation";
import DashboardOverview from "./dashboard/DashboardOverview/DashboardOverview";
import Signin from "./public/Signin/Signin";
import ForgotPassword from "./public/ForgotPassword/ForgotPassword";
import ResetPassword from "./public/ResetPassword/ResetPassword";
import NotFoundPage from "./public/NotFound/NotFound";
import ServerError from "./public/ServerError/ServerError";
import { DashboardMapping } from '../config/dashboards';
import PublicLoader from './routing/PublicLoader';
import RouteWithSidebar from './routing/RouteWithSidebar';
import NotFound from './public/NotFound/NotFound';
import UserProfile from './user/UserProfile';
import AccessLogger from './routing/AccessLogger';
import DashboardCloud from '../components/DashboardCloud/DashboardCloud';
import DashboardPublic from '../components/DashboardPublic/DashboardPublic';
import DashboardBattleCards from '../components/DashboardBattleCards/DashboardBattleCards';
import { passcodeRequest } from '../utils/request/api';
import DashboardEImpact from '../components/DashboardEImpact/DashboardEImpact';
import DashboardUsersLogs from '../components/DashboardUsersLogs/DashboardUsersLogs';
import Chatbot from "../components/Chatbot/Chatbot";

const isChatbotEnabled = (value) => value === true || value === "true";

const renderChatbot = (details) => {
  console.log("Chatbot details:", details);
  if (!isChatbotEnabled(details.chatbotEnabled)) {
    return null;
  }
  
  return (
    <Chatbot
      project={details.chatbotName}
      title={details.chatbotName || "Chatbot"}
    />
  );
};

const HomePage = () => {

  const userContext = useContext(UserContext);
  const [hideBar, setHideBar] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();


  const checkPasscode = async e => {
    const pc = searchParams.get("pc");
    if(pc) {
      const data = await passcodeRequest(pc);
      if (data.user){
        localStorage.setItem("hideProfile", "true");
        data.user.hideProfile = true;
        userContext.handleUserLogin(data);
        if(window.location.pathname !== "/"){
          navigate(window.location.pathname)
        }else{
          navigate(AppRoutes.DashboardOverview.path);
        }
      }
    }
  };

  useEffect(() => {checkPasscode()})

  return(
    <Routes>
      <Route element={<RouteWithSidebar hideBar={hideBar} setHideBar={setHideBar}/>}>
      {
        userContext.user && userContext.user.solutions.filter( s => !(s.solutionType === "LEAD_GENERATION")).map( s => {
          if(s.solutionType === "TABLEAU_PUBLIC"){
            
            const details = JSON.parse(s.details);

            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={<AccessLogger solutionId={s.id}><DashboardPublic userId={userContext.user.id} scope={s.scope} stickyFiltersEnabled={s.useStickyFiltersEnabled} solutionConfigurationEnabled={s.useSolutionConfigurationEnabled} sidebar={details.sidebar} setHideBar={setHideBar} link={details.url} width={parseInt(details.width)} height={parseInt(details.height)} hideToolbar={details.hideToolbar} /></AccessLogger>}
                key={`route_${s.name}`}
              />
            )
          }else if(s.solutionType === "TABLEAU_CLOUD"){

            const details = JSON.parse(s.details);

            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={<AccessLogger solutionId={s.id}><DashboardCloud userId={userContext.user.id} scope={s.scope} stickyFiltersEnabled={s.useStickyFiltersEnabled} solutionConfigurationEnabled={s.useSolutionConfigurationEnabled} sidebar={details.sidebar} setHideBar={setHideBar} link={details.url} width={parseInt(details.width)} height={parseInt(details.height)} locale={details.locale}  hideToolbar={details.hideToolbar}/>{renderChatbot(details)}</AccessLogger>}
                key={`route_${s.name}`}
              />
            )
          }else if(s.solutionType === "USERS_LOGS"){

            const details = JSON.parse(s.details);

            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={
                  <AccessLogger solutionId={s.id}>
                    <DashboardUsersLogs userId={userContext.user.id} scope={s.scope} stickyFiltersEnabled={s.useStickyFiltersEnabled} solutionConfigurationEnabled={s.useSolutionConfigurationEnabled} sidebar={details.sidebar} companies={details.companies} setHideBar={setHideBar} link={details.url} width={parseInt(details.width)} height={parseInt(details.height)} locale={details.locale}  hideToolbar={details.hideToolbar}/>
                  </AccessLogger>
                }
                key={`route_${s.name}`}
              />
            )
          }else if(s.solutionType === "EIMPACT"){

            const details = JSON.parse(s.details);

            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={<AccessLogger solutionId={s.id}><DashboardEImpact sidebar={details.sidebar} setHideBar={setHideBar} link={details.url} width={parseInt(details.width)} height={parseInt(details.height)} hideToolbar={details.hideToolbar}/></AccessLogger>}
                key={`route_${s.name}`}
              />
            )
          }else if(s.solutionType === "BATTLE_CARDS"){

            const details = JSON.parse(s.details);

            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={<AccessLogger solutionId={s.id}><DashboardBattleCards sidebar={details.sidebar} setHideBar={setHideBar} companySelected1={details.selection1 ? parseInt(details.selection1) - 1: 0} companySelected2={details.selection2 ? parseInt(details.selection2) - 1: 0} baseCompanies1={details.companies1} widthDashboard={parseInt(details.width)} heightDashboard={parseInt(details.height)} baseCompanies2={details.companies2} link={details.url} locale={details.locale}/>{renderChatbot(details)}</AccessLogger>}
                key={`route_${s.name}`}
              />
            )
          } else {
            const Component = DashboardMapping.private[s.code];
            return(
              <Route 
                exact path={AppRoutes.Dashboards_template.path+s.code} 
                element={<AccessLogger solutionId={s.id}><Component solutionId={s.id}/></AccessLogger>}
                key={`route_${s.name}`}
              />
            )
          }
        })
      }
      </Route>

      <Route element={<PublicLoader/>}>
        <Route exact path={AppRoutes.Presentation.path} element={<Presentation/>} />
        <Route exact path={AppRoutes.Signin.path} element={<Signin/>} />
        <Route exact path={AppRoutes.ForgotPassword.path} element={<ForgotPassword/>} />
        <Route exact path={AppRoutes.NotFound.path} element={<NotFoundPage/>} />
        <Route exact path={AppRoutes.ServerError.path} element={<ServerError/>} />
      </Route>
      <Route exact path={AppRoutes.ResetPassword.path} element={<ResetPassword/>} />

      {
        Object.entries(DashboardMapping.public).map( entry => {
          const id = entry[0]
          const Component = entry[1]
          return <Route 
            key={`public_${id}`} exact path={AppRoutes.Dashboards_template.path+id} 
            element={<AccessLogger publicAccess={true} solutionId={id}><Component solutionId={id}/></AccessLogger>}
           />
        })
      }

       {/* pages */}
       <Route element={<RouteWithSidebar hideBar={hideBar} setHideBar={setHideBar}/>}>
          <Route exact path={AppRoutes.DashboardOverview.path} element={<DashboardOverview/>}/>
          <Route exact path={AppRoutes.UserProfile.path} element={<UserProfile/>}/>
      </Route>
    
      {
        !userContext.isAuth && <Route 
          path={AppRoutes.Dashboards_template.path+':id'}
          element={<Signin/>}
        />
      }
      <Route path="/*" element={<NotFound/>}/>
    </Routes>
  )
};

export default HomePage;
